import { createFileRoute } from "@tanstack/react-router";

import { fetchPoliciesCancellation } from "@/loaders/policies";
import Policies from "@/pages/policies";

export const Route = createFileRoute(
  "/policies/$company/$location/cancellation"
)({
  component: CancellationPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return { meta: [{ title: loaderData.title }] };
  },
  loader: ({ params }) =>
    fetchPoliciesCancellation({
      data: { company: params.company, location: params.location },
    }),
});

function CancellationPage() {
  const data = Route.useLoaderData();
  return <Policies {...data} />;
}
